import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AccessExport as AccessExport23 } from 'projects/flow-gui-access/views/2.3/core'
import { AccessExport as AccessExport24 } from 'projects/flow-gui-access/views/2.4/core'

class AccessExport extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <AccessExport24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <AccessExport23 {...this.props} />
    } else return false
  }
}
export default connect(state => state)(AccessExport)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/core/access.js